export default __webpack_public_path__ + "static/media/visual.eb23e562.svg";